(function () {
  'use strict';

  angular
    .module('blockade')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('blockade', {
        url: '/blockade',
        templateUrl: 'blockade/blockade.tpl.html',
        controller: 'BlockadeCtrl',
        controllerAs: 'vm'
      });
  }
}());
